import type { Stripe } from '@stripe/stripe-js';
// The `/pure` entry only fetches js.stripe.com when `loadStripe` is called.
// The default entry injects the script as a side effect of being imported,
// which put ~270 KB of Stripe.js on every page of the app.
import { loadStripe } from '@stripe/stripe-js/pure';

import { environment } from 'environments/environment';

let platformStripe: Promise<Stripe | null> | undefined;

/**
 * The platform-account Stripe instance, created on first use and shared.
 *
 * Call this where the promise is needed (e.g. `<Elements stripe={...}>`)
 * rather than at module scope — a module-scope call runs as soon as the file
 * is imported, which is on every page for anything in the main bundle.
 * @returns The shared Stripe.js promise for the platform account.
 */
export function getPlatformStripe(): Promise<Stripe | null> {
  if (!platformStripe) {
    platformStripe = loadStripe(environment.stripeKey);
  }
  return platformStripe;
}
